import { clsx } from "clsx";
import { twMerge } from "tailwind-merge";

export function cn(...inputs) {
  return twMerge(clsx(inputs));
}

export function formatDate(dateString) {
  if (!dateString) return '';
  const date = new Date(dateString);
  return date.toLocaleDateString('en-US', {
    year: 'numeric',
    month: 'short',
    day: 'numeric',
  });
}

export function formatDateTime(dateString) {
  if (!dateString) return '';
  const date = new Date(dateString);
  return date.toLocaleString('en-US', {
    year: 'numeric',
    month: 'short',
    day: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
  });
}

export function formatTime(dateString) {
  if (!dateString) return '';
  const date = new Date(dateString);
  return date.toLocaleTimeString('en-US', {
    hour: '2-digit',
    minute: '2-digit',
  });
}

export function getInitials(name) {
  if (!name) return '?';
  return name
    .split(' ')
    .map((n) => n[0])
    .join('')
    .toUpperCase()
    .slice(0, 2);
}

export function calculateBMI(heightCm, weightKg) {
  if (!heightCm || !weightKg) return null;
  const heightM = heightCm / 100;
  return (weightKg / (heightM * heightM)).toFixed(1);
}

export function getBMICategory(bmi) {
  if (!bmi) return '';
  if (bmi < 18.5) return 'Underweight';
  if (bmi < 25) return 'Normal';
  if (bmi < 30) return 'Overweight';
  return 'Obese';
}

export function healthConcernLabel(concern) {
  const labels = {
    fertility: 'Fertility',
    gut_health: 'Gut Health',
    vaginal_health: 'Vaginal Health',
    chronic_pain: 'Chronic Pain',
    inflammation: 'Inflammation',
    longevity: 'Longevity',
    preventative_care: 'Preventative Care',
  };
  return labels[concern] || concern;
}

export function reportTypeLabel(type) {
  const labels = {
    gut_microbiome: 'Gut Microbiome',
    vaginal_microbiome: 'Vaginal Microbiome',
    other: 'Other',
  };
  return labels[type] || type;
}

export function getRatingColor(rating) {
  if (rating >= 4) return '#8DA399'; // Sage green - good
  if (rating >= 3) return '#E8C495'; // Warning yellow
  return '#D68282'; // Error red
}

export function getRatingLabel(rating) {
  const labels = {
    1: 'Very Poor',
    2: 'Poor',
    3: 'Okay',
    4: 'Good',
    5: 'Excellent',
  };
  return labels[rating] || '';
}
